"use client";

import { useEffect } from "react";
import { trackPhoneClick, trackEmailClick, trackMapsClick, trackProfileClick } from "../../lib/trackConversion";

/**
 * Mounted once in LayoutWrapper. One delegated click listener captures every
 * contact-intent click on the site (current and future) without each component
 * wiring its own handler:
 *   - tel:   links  -> phone_call   (+ Google Ads "Click to call" conversion)
 *   - mailto: links -> email_click  (GA4 event)
 *   - Google Maps / GBP links -> maps_click (GA4 event)
 * Each tracker dedups, so this never double-fires with itself.
 */
const MAPS_SELECTORS = [
  'a[href*="maps.app.goo.gl"]',
  'a[href*="maps.google"]',
  'a[href*="g.page"]',
  'a[href*="goo.gl/maps"]',
  'a[href*="share.google"]',
  'a[href*="google.com/maps"]',
];

export default function ContactTracker() {
  useEffect(() => {
    const onClick = (e) => {
      const link = e.target.closest?.(
        `a[href^="tel:"], a[href^="mailto:"], ${MAPS_SELECTORS.join(", ")}, a[href^="https://www.aicanada.ca/appraisers/910564"]`
      );
      if (!link) return;
      const href = link.getAttribute("href") || "";
      if (href.startsWith("tel:")) {
        trackPhoneClick(href.replace("tel:", ""), "tel_link");
      } else if (href.startsWith("mailto:")) {
        trackEmailClick(href.replace("mailto:", "").split("?")[0], "mailto_link");
      } else if (["https://www.aicanada.ca/appraisers/910564", "https://www.aicanada.ca/appraisers/910564/"].includes(href.split(/[?#]/)[0])) {
        trackProfileClick();
      } else {
        trackMapsClick(href, "maps_link");
      }
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return null;
}
